export const ImpressumPage = () => {
  return (
    <main data-testid="impressum-page" className="bg-[#08080a] min-h-screen pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-pink-brand mb-4">Rechtliches</p>
        <h1 className="font-display font-bold text-4xl md:text-5xl text-white tracking-tight mb-12">Impressum</h1>

        <div className="space-y-10 text-neutral-300 leading-relaxed">
          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">Angaben zum Unternehmen</h2>
            <p>
              Vollmermontagen GmbH<br />
              Hinwilerstrasse 11<br />
              8626 Ottikon<br />
              Schweiz
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">Kontakt</h2>
            <p>
              Telefon Büro: +41 44 935 33 03 (09:00–18:00)<br />
              Mobile: +41 79 954 60 50 (07:00–20:00)<br />
              E-Mail: r.vollmermontagen@gmail.com
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">Vertretungsberechtigte Person</h2>
            <p>Remo Vollmer, Geschäftsführer</p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">Handelsregister</h2>
            <p>
              Eingetragen im Handelsregister des Kantons Zürich.<br />
              Handelsregister-Nummer: CH-020.4.090.881-3<br />
              MwSt-Nummer: CHE-482.841.226 MwSt
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">Haftungsausschluss</h2>
            <p>
              Die Inhalte dieser Website wurden mit grösster Sorgfalt erstellt. Für die Richtigkeit,
              Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr.
              Verweise und Links auf Websites Dritter liegen ausserhalb unseres Verantwortungsbereichs.
              Für solche Websites wird jegliche Verantwortung abgelehnt.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">Urheberrechte</h2>
            <p>
              Die Inhalte und Werke auf dieser Website (Texte, Bilder, Logo) sind urheberrechtlich
              geschützt. Jede Verwendung ausserhalb der Grenzen des Urheberrechts bedarf der
              vorherigen schriftlichen Zustimmung der Vollmermontagen GmbH.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
};
